import { supabase } from "../lib/supabase";
import { useDocumentTitle } from "../lib/useDocumentTitle";

export default function AccessDenied() {
  useDocumentTitle("Access denied");
  return (
    <div className="grid min-h-full place-items-center">
      <div className="max-w-md space-y-3 rounded-lg border border-border bg-panel p-6 text-center">
        <h1 className="text-lg font-semibold">Access denied</h1>
        <p className="text-sm text-muted">
          Your account is not on the platform admin list. If you believe this is
          a mistake, contact the team via the engineering Slack channel.
        </p>
        <button
          onClick={() => supabase.auth.signOut()}
          className="mt-3 rounded border border-border px-3 py-1.5 text-sm hover:bg-bg"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
